/**
 * Naming convention for Action Types
 * Two type of actions- User Generated || System Generated
 * Respective prefixes- USER | SYSTEM
 *
 *
 * Summarizer- smzr
 * Paraphraser- pphr
 * Citation Generator- ctgr
 * Ghost Writer- gtwr
 * Common- comn
 */

/**
 * System generated actions
 */
export const SHOW_TNC_DIALOG = 'pphr/system/show_tnc_dialog';
export const OUTPUTBOX_EDITABLE_MOBILE = 'pphr/system/output_box_editable_for_mobile';
// export const CHANGE_LAST_SUBMISSION = 'pphr/system/last_submission';
// export const SET_SHOW_REPHRASE = 'pphr/system/show_rephrase';
export const SET_SHOW_CHAR_LIMIT_MESSAGE = 'pphr/system/show_char_limit_message';
export const SET_STARTED_QUILLING = 'pphr/system/started_quilling';
export const SET_INPUT_SENTENCES = 'pphr/system/set_input_sentences';
export const SET_OUTPUT_PARAPHRASER_UPDATER = 'pphr/system/updated_output_paraphraser';
export const SET_COMPARE_MODE_UPDATER = 'pphr/system/updated_compare_mode';
export const SET_SHOW_REPHRASE_AGAIN = 'pphr/system/show_rephrase_again';
export const SET_NUMBER_OF_COMPLETED_PARAPHRASES = 'pphr/system/set_completed_paraphrases_count';
export const SET_SENTENCE_SPLITTER_CONTEXT_MESSAGE = 'pphr/system/sentence_split_context_message';
export const GET_LOCAL_STORAGE_DATA = 'pphr/system/get_local_storage_data';
export const SET_UPLOAD_FILE_INFO = 'pphr/user/uploaded_file_information';
export const USER_ONBOARDING_STATUS = 'pphr/system/user_onboarding_status';
export const USER_ONBOARDING_STEP = 'pphr/system/user_onboarding_step';
export const SET_CYRILLIC_FREE_TEXT = 'pphr/system/set_cyrillic_free_text';
export const SET_BEAMS = 'pphr/system/setBeams';
export const IS_DIALOG_OPEN = 'pphr/system/is_dialog_open';
export const SET_REPHRASE_TOOLTIP = 'pphr/system/set_rephrase_tooltip';
export const SET_SENTENCE_CONTROL_TOOLBAR_STATE = 'pphr/system/set_sentence_control_toolbar_state';
export const SET_MERGE_MODAL_STATE = 'pphr/system/set_merge_modal_state';
export const SHOW_PERSISTED_SENTENCE_CONTROL = 'pphr/system/show_persisted_sentence_control';
/**
 * User generated actions
 */
export const USER_CLICKED_TRY_SAMPLE = 'pphr/user/clicked_try_sample_button';
export const USER_RESETTED_PARAPHRASE_STATE = 'pphr/user/resetted_paraphrase_state';
export const SET_FOCUSED_INPUT_PARAPHRASER = 'pphr/user/focused_input_paraphraser';
export const SET_INPUT_TEXT = 'pphr/user/changing_input';
export const SET_STRENGTH = 'pphr/user/changed_strength';
export const SET_SHOW_LEGEND = 'pphr/user/changed_settings_legend';
export const SET_YELLOW_TO_HIGHLIGHT_SENTENCE =
  'pphr/user/changed_settings_yellow_highlight_sentence';
export const SET_SHOW_LONGEST_UNCHANGED_WORD_COLOR =
  'pphr/user/changed_settings_longest_unchanged_word_color';
export const SET_SHOW_CHANGE_WORD_COLOR = 'pphr/user/changed_settings_word_color';
export const SET_SHOW_SENTENCE_RESTRUCTURE_LINE =
  'pphr/user/changed_settings_sentence_restructure_line';
export const USER_FINISHED_TYPING = 'pphr/user/user_finished_typing';
export const USER_CHANGED_SENTENCE_LOCK_STATUS = 'pphr/user/changed_lock_status';
export const UNDO_LAST_PARAPHRASED_STATE = 'pphr/user/undo_last_paraphrased_state';
export const SET_FREEZE_WORDS = 'pphr/user/set_freeze_words';
export const USER_CHANGED_WORD_FLIPPER = 'pphr/user/changed_word_flipper';

// export const FIRST_PARAPHRASE = 'pphr/first_paraphrase';
// export const TOGGLE_STATE = 'pphr/set_toogle'; //Experimental flag for redux.
// export const SET_NUMBER_OF_SENTENCES_IN_ARTICLE = 'pphr/number_of_sentences_in_article';
export const SET_SHOW_REQUILL_LABEL = 'pphr/requill_label';
export const SET_QUILL_CONFIG_OPEN_MOBILE = 'pphr/quill_config_open_in_mobile';
export const SET_FIRST_QUILL_SESSION = 'pphr/first_quill_session';

// export const CHANGE_NUMBER_OF_CHARACTER = 'pphr/change_number_of_character'; //not using currently.
// export const WORD_COLOR_UPDATE = 'pphr/user/word_color_update';
// export const SET_PERSISTENT_INPUT_TEXT = 'pphr/setPersistentInputText';
// export const SET_ARTICLE_CONTROLS = 'pphr/article_controls';
